/**
 * API 配置工具
 * 統一管理 API 基礎 URL，支持開發和生產環境
 */

/**
 * 獲取 API 基礎 URL
 * 優先使用環境變量 REACT_APP_API_URL
 * 如果沒有設置，則從 REACT_APP_GRAPHQL_URI 提取（去掉 /graphql）
 * 最後回退到 localhost:4000（開發環境）
 */
export const getApiUrl = () => {
  // 優先使用專門的 API URL 環境變量
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // 如果沒有，嘗試從 GraphQL URI 提取
  if (process.env.REACT_APP_GRAPHQL_URI) {
    const graphqlUri = process.env.REACT_APP_GRAPHQL_URI;
    // 移除 /graphql 路徑
    return graphqlUri.replace(/\/graphql$/, '');
  }
  
  // 開發環境默認值
  return 'http://localhost:4000';
};

/**
 * 獲取完整的 API 端點 URL
 * @param {string} endpoint - API 端點路徑（如 '/api/admin/login'）
 * @returns {string} 完整的 URL
 */
export const getApiEndpoint = (endpoint) => {
  const baseUrl = getApiUrl();
  // 確保 endpoint 以 / 開頭
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${path}`;
};

